import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_badges';

const badgesQuery = `
    query badges($listingId : [String]!) {
        badges(listingTriad : $listingId) {
            badgeGroups {
                id
                name
                badges {
                    id
                    name
                    helpText
                }
            }
        }
    }
`;

function badgesGraphQl({listingId, locale}) {
    return graphqlQuery(OPERATION_NAME, badgesQuery, {listingId}, locale).catch(() => null);
}

export default badgesGraphQl;
export {badgesGraphQl, OPERATION_NAME, badgesQuery};
